var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('span',{staticClass:"z-10 cursor-pointer",class:_vm.spanPositioningClasses,on:{"click":_vm.handlePagination}},[_c('svg-icon',{staticClass:"transition-all duration-200 text-gold-500 w-8 h-4",class:_vm.iconClasses,attrs:{"icon":"arrow-horizontal"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }